::ng-deep app-entity-chart-import-toolbar{flex:1 0 auto!important}::ng-deep app-entity-chart-import-toolbar .page-title{padding-left:30px}::ng-deep app-entity-chart-import-toolbar .page-title h1{font-size:1rem;font-weight:600}
/*# sourceMappingURL=entity-chart-import-toolbar.component-EAQCJBVK.css.map */
